import React, { Component, Fragment } from 'react';
import { PATHS, DETAIL_ACTIONS } from "../../../../../constants/Define";
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import { isEqual } from 'lodash';
import Wrapper from './../../../common/component/Wrapper';
import Input from "../../../common/component/Input";
import { Radio } from 'antd';
import Baggage from '../../../../../models/Baggage';
import './BaggageDetail.less';

const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
    isGetItem: false
};

class BaggageDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            isSubmit: false,
            baggage: this.props.baggageState.detail.baggage,
            isDomestic: this.props.baggageState.detail.baggage.isDomestic || true,
        }
    }

    componentDidMount() {
        this.initDetail()
    }
    

    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getBaggageDetail(id);
        }
    }

    componentWillUnmount() {
        this.props.setBaggageDetail(new Baggage())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.baggageState.detail.baggage && !isEqual(nextProps.baggageState.detail.baggage, this.props.baggageState.detail.baggage)) {
            this.setState({ 
                baggage: nextProps.baggageState.detail.baggage, 
                isDomestic: nextProps.baggageState.detail.baggage.isDomestic,
                action: nextProps.baggageState.detail.baggage.id ? 'UPDATE' : this.state.action 
            });
        }
    }

    inputForm = (t, fieldName, required = false) => (
        <HMS.FormWrapperInputComponent
            isRequired={required}
            isValidation={required}
            dataValidation={this.state.baggage[fieldName]}
            validation={this.state.validation[fieldName]}
            labelTitle={t(`item.baggage.${fieldName}`)}
        >
            <Input placeholder="" type={`text`}
                className={`form-control`}
                name={fieldName} onChange={(e) => this.onChange(fieldName, e.target.value)}
                value={Func.checkUndefine(this.state.baggage[fieldName])} />
        </HMS.FormWrapperInputComponent>
    )

    render() {
        const { t } =  this.props;
        const { action, isSubmit, isGetItem } = this.state;

        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="baggage-detail-page">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'baggages'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.baggage.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.baggage.title')}`.toLowerCase()))
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            onClickBack={this.onClickBack}
                            submitButtonRight={true}
                            statusActiveName={`isActive`}
                        >
                            <Wrapper className='col-md-12 basic-section'>
                                
                                <HMS.FormWrapperItem>
                                <Wrapper className="col-md-3" />
                                <Wrapper className="col-md-6">
                                    {this.inputForm(t, 'airlineCode', true)}
                                    {this.inputForm(t, 'class', true)}
                                    {this.inputForm(t, 'handBaggage')}
                                    {this.inputForm(t, 'baggageAllowance')}
                                    <HMS.FormWrapperInputComponent
                                        labelTitle={t(`item.baggage.isDomestic`)}
                                    >
                                        <Radio.Group onChange={this.selectType}value={this.state.isDomestic} className="radio-type-export">
                                            <Radio.Button value={true}>Trong nước</Radio.Button>
                                            <Radio.Button value={false}>Quốc tế</Radio.Button>
                                        </Radio.Group>
                                    </HMS.FormWrapperInputComponent>
                                </Wrapper>
                                <Wrapper className="col-md-3" />
                                </HMS.FormWrapperItem>
                            </Wrapper>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        )
    }

    selectType = (e) => {
        this.setState({ isDomestic: e.target.value });
    }

    onChange = (fieldName, value) => {
        const baggage = this.state.baggage;
        const keyString = fieldName === 'key' ? this.convertStringKey(value) : value;
        baggage[fieldName] = keyString.trimLeft();
        this.setState({ baggage });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { action } = this.state;
        const baggage = this.state.baggage;
        baggage.isDomestic = this.state.isDomestic;
        if (this.validate()) {
            if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createBaggageDetail(baggage)
            } else {
                this.props.updateBaggageDetail({ baggage, props: this.props })
            }
        }
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                airlineCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.baggage.airlineCode`)),
                class: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.baggage.class`)),
            }
        };
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.baggage, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    onClickBack = () => {
        this.props.history.push(PATHS.BAGGAGE.LIST.path);
    }
}

export default BaggageDetail;
